import React from "react";
import { EventEmitter } from "events";

export const EventContext = React.createContext<EventEmitter>(null!);
